import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaExclamationTriangle, FaTrash } from 'react-icons/fa';

export function DeleteConfirmationModal({ show, onHide, feature, onConfirm }) {
  if (!feature) return null;

  const getFeatureType = () => {
    if (feature.geojson?.type === 'Polygon' || feature.geojson?.type === 'MultiPolygon') return 'polygon';
    if (feature.geojson?.type === 'LineString') return 'line';
    if (feature.geojson?.type === 'Point') return 'point';
    return 'feature';
  };

  const getFeatureDisplayName = () => {
    return feature.name || 'Unnamed feature';
  };

  const featureType = getFeatureType();
  const featureName = getFeatureDisplayName();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaExclamationTriangle className="text-warning" />
          Confirm Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete <strong>"{featureName}"</strong>?
        </p>
        <p className="text-muted mb-0">
          This {featureType} will be permanently removed and cannot be undone.
          You can refresh the page to see the changes.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={onConfirm}
          className="d-flex align-items-center gap-2"
        >
          <FaTrash />
          Delete {featureType}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
